
import React from 'react';

const NotFoundPage = props => {
    return (
        <div className="error-page">
          <div className="d-flex align-items-center justify-content-center vh-100">
              <div className="d-flex align-items-center justify-content-center vh-100">
                  <div className="d-flex flex-1 flex-col items-center px-4 py-4 bg-white rounded max-w-sm shadow-lg align-items-center flex-column" >
                        <svg className="w-16 h-16 mt-3 feather feather-clipboard" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#faca15" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
                        <h5 className="text-center mt-4">Page not available</h5>
                        <p className="text-center mt-2 text-txt text-lg">Sorry, this page is not available</p>
                        <div className="flex justify-center"></div>
                  </div>
              </div>
          </div>
        </div>
    );
};

export default NotFoundPage;